import Keycloak from 'keycloak-js';

const ENDPOINT = process.env.REACT_APP_KEYCLOAK_ENDPOINT;
const REALM = process.env.REACT_APP_KEYCLOAK_REALM;
const CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

const keycloak = new Keycloak({
  url: ENDPOINT,
  realm: REALM, // corregí el typo "relam"
  clientId: CLIENT_ID
});

export default keycloak;